import styled, { css } from 'styled-components'

export const StyledGlobalLayout = styled.div<{ fixedHeader: boolean }>`
  ${({ theme, fixedHeader }) => css`
    ${fixedHeader &&
    css`
      padding-top: 72px;
    `}
    min-height: 100vh;
    min-width: 1024px;
    background: ${theme.colors.greyLight};
  `}
`
